var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"list-view"},[_c('div',{ref:"scrollContainer",staticClass:"scroll-container",attrs:{"data-scrollbar-deactivate-mobile":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }